import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const propertyAssetService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
    statisticSummary,
};

const MODULE = {
    PROPERTY: 'properties',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            group: filter?.group,
            property_status: filter?.propertyStatus,
            property_type: filter?.propertyType,
            property_tenure: filter?.propertyTenure,
            property_category: filter?.propertyCategory,
            is_asset: 1,
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PROPERTY}`, request);
}

export function store (data) {
    const formData = new FormData();
    formData.append(`_method`, 'POST');
    if (data.property) {
        if (data.property.groupUuid) formData.append(`property[group_uuid]`, data.property.groupUuid);
        if (data.property.propertyTypeUuid) formData.append(`property[property_type_uuid]`, data.property.propertyTypeUuid);
        if (data.property.locationUuid) formData.append(`property[location_uuid]`, data.property.locationUuid);
        if (data.property.registeredOwner) formData.append(`property[registered_owner]`, data.property.registeredOwner);
        if (data.property.company) formData.append(`property[company]`, data.property.company);
        if (data.property.description) formData.append(`property[description]`, data.property.description);
        if (data.property.remark) formData.append(`property[remark]`, data.property.remark);
        if (data.property.address1) formData.append(`property[address_1]`, data.property.address1);
        if (data.property.address2) formData.append(`property[address_2]`, data.property.address2);
        if (data.property.address3) formData.append(`property[address_3]`, data.property.address3);
        if (data.property.city) formData.append(`property[city]`, data.property.city);
        if (data.property.state) formData.append(`property[state]`, data.property.state);
        if (data.property.postcode) formData.append(`property[postcode]`, data.property.postcode);
        if (data.property.lat) formData.append(`property[lat]`, data.property.lat);
        if (data.property.lng) formData.append(`property[lng]`, data.property.lng);
        if (data.property.image instanceof File) formData.append('property[image]', data.property.image); 
        formData.append(`property[is_asset]`, data.property.isAsset);
        formData.append(`property[is_tenanted]`, data.property.isTenanted);
        formData.append(`property[is_malaysia]`, data.property.isMalaysia);
        formData.append(`property[is_personal]`, data.property.isPersonal);
    }

    if (data.asset) {
        if (data.asset.propertyTenureUuid) formData.append(`asset[property_tenure_uuid]`, data.asset.propertyTenureUuid);
        if (data.asset.propertyCategoryUuid) formData.append(`asset[property_category_uuid]`, data.asset.propertyCategoryUuid);
        if (data.asset.propertyStatusUuid) formData.append(`asset[property_status_uuid]`, data.asset.propertyStatusUuid);
        if (data.asset.propertyActionUuid) formData.append(`asset[property_action_uuid]`, data.asset.propertyActionUuid);
        if (data.asset.utilizeBuildingSizeUnitUuid) formData.append(`asset[utilize_building_size_unit_uuid]`, data.asset.utilizeBuildingSizeUnitUuid);
        if (data.asset.utilizeLandSizeUnitUuid) formData.append(`asset[utilize_land_size_unit_uuid]`, data.asset.utilizeLandSizeUnitUuid);
        if (data.asset.buildingSizeUnitUuid) formData.append(`asset[building_size_unit_uuid]`, data.asset.buildingSizeUnitUuid);
        if (data.asset.landSizeUnitUuid) formData.append(`asset[land_size_unit_uuid]`, data.asset.landSizeUnitUuid);
        if (data.asset.fileId) formData.append(`asset[file_id]`, data.asset.fileId);
        if (data.asset.lotId) formData.append(`asset[lot_id]`, data.asset.lotId);
        if (data.asset.hakMilikId) formData.append(`asset[hak_milik_id]`, data.asset.hakMilikId);
        if (data.asset.purchaseDate) formData.append(`asset[purchase_date]`, data.asset.purchaseDate);
        if (data.asset.purchaseValuePsf) formData.append(`asset[purchase_value_psf]`, data.asset.purchaseValuePsf);
        if (data.asset.purchaseValueTotal) formData.append(`asset[purchase_value_total]`, data.asset.purchaseValueTotal);
        if (data.asset.nbvValue) formData.append(`asset[nbv_value]`, data.asset.nbvValue);
        if (data.asset.soldPrice) formData.append(`asset[sold_price]`, data.asset.soldPrice);
        if (data.asset.yield) formData.append(`asset[yield]`, data.asset.yield);
        if (data.asset.revaluationDate) formData.append(`asset[revaluation_date]`, data.asset.revaluationDate);
        if (data.asset.revaluationValuePsf) formData.append(`asset[revaluation_value_psf]`, data.asset.revaluationValuePsf);
        if (data.asset.revaluationValueTotal) formData.append(`asset[revaluation_value_total]`, data.asset.revaluationValueTotal);
        if (data.asset.buildingSize) formData.append(`asset[building_size]`, data.asset.buildingSize);
        if (data.asset.landSize) formData.append(`asset[land_size]`, data.asset.landSize);
        if (data.asset.utilizeBuildingSize) formData.append(`asset[utilize_building_size]`, data.asset.utilizeBuildingSize);
        if (data.asset.utilizeBuildingPercentage) formData.append(`asset[utilize_building_percentage]`, data.asset.utilizeBuildingPercentage);
        if (data.asset.utilizeLandSize) formData.append(`asset[utilize_land_size]`, data.asset.utilizeLandSize);
        if (data.asset.utilizeLandPercentage) formData.append(`asset[utilize_land_percentage]`, data.asset.utilizeLandPercentage);
        if (data.asset.marketValue) formData.append(`asset[market_value]`, data.asset.marketValue);
        if (data.asset.estimatedRental) formData.append(`asset[estimated_rental]`, data.asset.estimatedRental);
        if (data.asset.estimatedRentalMonthly) formData.append(`asset[estimated_rental_monthly]`, data.asset.estimatedRentalMonthly);
        if (data.asset.estimatedRentalYearly) formData.append(`asset[estimated_rental_yearly]`, data.asset.estimatedRentalYearly);
        if (data.asset.leaseHoldExpiredDate) formData.append(`asset[lease_hold_expired_date]`, data.asset.leaseHoldExpiredDate);
        if (data.asset.leaseYear) formData.append(`asset[lease_year]`, data.asset.leaseYear);
        if (data.asset.leaseYearRemaining) formData.append(`asset[lease_year_remaining]`, data.asset.leaseYearRemaining);
        if (data.asset.bandarPekanMukim) formData.append(`asset[bandar_pekan_mukim]`, data.asset.bandarPekanMukim);
        if (data.asset.grade) formData.append(`asset[grade]`, data.asset.grade);
        if (data.asset.isCompliance) formData.append(`asset[is_compliance]`, data.asset.isCompliance);
        if (data.asset.complianceRemark) formData.append(`asset[compliance_remark]`, data.asset.complianceRemark);
    }

    return apiHelper(API_URL).post(`/${MODULE.PROPERTY}`, formData);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PROPERTY}/${uuid}`);
}

export function update (data) {
    const formData = new FormData();
    formData.append(`_method`, 'PUT');

    if (data.property) {
        if (data.property.groupUuid) formData.append(`property[group_uuid]`, data.property.groupUuid);
        if (data.property.propertyTypeUuid) formData.append(`property[property_type_uuid]`, data.property.propertyTypeUuid);
        if (data.property.locationUuid) formData.append(`property[location_uuid]`, data.property.locationUuid);
        if (data.property.registeredOwner) formData.append(`property[registered_owner]`, data.property.registeredOwner);
        if (data.property.company) formData.append(`property[company]`, data.property.company);
        if (data.property.description) formData.append(`property[description]`, data.property.description);
        if (data.property.remark) formData.append(`property[remark]`, data.property.remark);
        if (data.property.address1) formData.append(`property[address_1]`, data.property.address1);
        if (data.property.address2) formData.append(`property[address_2]`, data.property.address2);
        if (data.property.address3) formData.append(`property[address_3]`, data.property.address3);
        if (data.property.city) formData.append(`property[city]`, data.property.city);
        if (data.property.state) formData.append(`property[state]`, data.property.state);
        if (data.property.postcode) formData.append(`property[postcode]`, data.property.postcode);
        if (data.property.lat) formData.append(`property[lat]`, data.property.lat);
        if (data.property.lng) formData.append(`property[lng]`, data.property.lng);
        if (data.property.image instanceof File) formData.append('property[image]', data.property.image);
        formData.append(`property[is_asset]`, data.property.isAsset);
        formData.append(`property[is_tenanted]`, data.property.isTenanted);
        formData.append(`property[is_malaysia]`, data.property.isMalaysia);
        formData.append(`property[is_personal]`, data.property.isPersonal);
    }

    if (data.asset) {
        if (data.asset.propertyTenureUuid) formData.append(`asset[property_tenure_uuid]`, data.asset.propertyTenureUuid);
        if (data.asset.propertyCategoryUuid) formData.append(`asset[property_category_uuid]`, data.asset.propertyCategoryUuid);
        if (data.asset.propertyStatusUuid) formData.append(`asset[property_status_uuid]`, data.asset.propertyStatusUuid);
        if (data.asset.propertyActionUuid) formData.append(`asset[property_action_uuid]`, data.asset.propertyActionUuid);
        if (data.asset.utilizeBuildingSizeUnitUuid) formData.append(`asset[utilize_building_size_unit_uuid]`, data.asset.utilizeBuildingSizeUnitUuid);
        if (data.asset.utilizeLandSizeUnitUuid) formData.append(`asset[utilize_land_size_unit_uuid]`, data.asset.utilizeLandSizeUnitUuid);
        if (data.asset.buildingSizeUnitUuid) formData.append(`asset[building_size_unit_uuid]`, data.asset.buildingSizeUnitUuid);
        if (data.asset.landSizeUnitUuid) formData.append(`asset[land_size_unit_uuid]`, data.asset.landSizeUnitUuid);
        if (data.asset.fileId) formData.append(`asset[file_id]`, data.asset.fileId);
        if (data.asset.lotId) formData.append(`asset[lot_id]`, data.asset.lotId);
        if (data.asset.hakMilikId) formData.append(`asset[hak_milik_id]`, data.asset.hakMilikId);
        if (data.asset.purchaseDate) formData.append(`asset[purchase_date]`, data.asset.purchaseDate);
        if (data.asset.purchaseValuePsf) formData.append(`asset[purchase_value_psf]`, data.asset.purchaseValuePsf);
        if (data.asset.purchaseValueTotal) formData.append(`asset[purchase_value_total]`, data.asset.purchaseValueTotal);
        if (data.asset.nbvValue) formData.append(`asset[nbv_value]`, data.asset.nbvValue);
        if (data.asset.soldPrice) formData.append(`asset[sold_price]`, data.asset.soldPrice);
        if (data.asset.yield) formData.append(`asset[yield]`, data.asset.yield);
        if (data.asset.revaluationDate) formData.append(`asset[revaluation_date]`, data.asset.revaluationDate);
        if (data.asset.revaluationValuePsf) formData.append(`asset[revaluation_value_psf]`, data.asset.revaluationValuePsf);
        if (data.asset.revaluationValueTotal) formData.append(`asset[revaluation_value_total]`, data.asset.revaluationValueTotal);
        if (data.asset.buildingSize) formData.append(`asset[building_size]`, data.asset.buildingSize);
        if (data.asset.landSize) formData.append(`asset[land_size]`, data.asset.landSize);
        if (data.asset.utilizeBuildingSize) formData.append(`asset[utilize_building_size]`, data.asset.utilizeBuildingSize);
        if (data.asset.utilizeBuildingPercentage) formData.append(`asset[utilize_building_percentage]`, data.asset.utilizeBuildingPercentage);
        if (data.asset.utilizeLandSize) formData.append(`asset[utilize_land_size]`, data.asset.utilizeLandSize);
        if (data.asset.utilizeLandPercentage) formData.append(`asset[utilize_land_percentage]`, data.asset.utilizeLandPercentage);
        if (data.asset.marketValue) formData.append(`asset[market_value]`, data.asset.marketValue);
        if (data.asset.estimatedRental) formData.append(`asset[estimated_rental]`, data.asset.estimatedRental);
        if (data.asset.estimatedRentalMonthly) formData.append(`asset[estimated_rental_monthly]`, data.asset.estimatedRentalMonthly);
        if (data.asset.estimatedRentalYearly) formData.append(`asset[estimated_rental_yearly]`, data.asset.estimatedRentalYearly);
        if (data.asset.leaseHoldExpiredDate) formData.append(`asset[lease_hold_expired_date]`, data.asset.leaseHoldExpiredDate);
        if (data.asset.leaseYear) formData.append(`asset[lease_year]`, data.asset.leaseYear);
        if (data.asset.leaseYearRemaining) formData.append(`asset[lease_year_remaining]`, data.asset.leaseYearRemaining);
        if (data.asset.bandarPekanMukim) formData.append(`asset[bandar_pekan_mukim]`, data.asset.bandarPekanMukim);
        if (data.asset.grade) formData.append(`asset[grade]`, data.asset.grade);
        if (data.asset.isCompliance) formData.append(`asset[is_compliance]`, data.asset.isCompliance);
        if (data.asset.complianceRemark) formData.append(`asset[compliance_remark]`, data.asset.complianceRemark);
    }

    return apiHelper(API_URL).post(`/${MODULE.PROPERTY}/${data.uuid}`, formData);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.PROPERTY}/${data.uuid}`);
}

export function statisticSummary () {
    return apiHelper(API_URL).get(`/${MODULE.PROPERTY}/statistic-summaries`);
}
